import React from 'react';
import { motion } from 'framer-motion';

const PageHero = ({ label, title, description, backgroundImage }) => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center">
      <div className="absolute inset-0">
        {backgroundImage ? (
          <>
            <div 
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url('${backgroundImage}')` }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/75 to-background" />
          </>
        ) : (
          <div className="absolute inset-0 bg-gradient-to-b from-beige-dark via-background to-background" />
        )}
      </div>

      <div className="relative container-luxury pt-32 pb-20">
        <motion.div
          initial={{ y: 40 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          {label && (
            <motion.span
              initial={{ y: 20 }}
              animate={{ y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="text-label text-primary mb-4 block"
            >
              {label}
            </motion.span>
          )}
          <motion.h1
            initial={{ y: 30 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-display font-serif text-foreground mb-6"
          >
            {title}
          </motion.h1>
          {description && (
            <motion.p
              initial={{ y: 30 }}
              animate={{ y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="text-body-lg text-muted-foreground"
            >
              {description}
            </motion.p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
